import React from 'react';
import IconWrapper from '../../../../../IconWrapper';
import { FiSearch } from 'react-icons/fi';
import OmbudsmanPredictionTile from './OmbudsmanPredictionTile';
import OmbudsmanAdvisorModal from './OmbudsmanAdvisorModal';
import { FOSOpinion } from '../../../../../../types/signals-live';

type Props = {
  signalId: string;
  fosOpinion?: FOSOpinion | null;
};

const InvestigateSection: React.FC<Props> = ({ signalId, fosOpinion }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <IconWrapper icon={FiSearch} className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-bold text-gray-900">Investigate</span>
      </div>

      {/* Grid is for future tiles; currently one tile */}
      <div className="grid grid-cols-1 gap-3">
        <OmbudsmanPredictionTile prediction={fosOpinion} onOpen={() => setOpen(true)} />
      </div>

      <OmbudsmanAdvisorModal
        open={open}
        onClose={() => setOpen(false)}
        signalId={signalId}
        fosOpinion={fosOpinion || null}
      />
    </div>
  );
};

export default React.memo(InvestigateSection);

